// Derived from vue-element-dialog-draggable package under the Apache v2 license.
// Reference my index_03.js from training copies.

"use strict";
let vueElementDialogDraggable = {};

// eslint-disable-next-line no-unused-vars
vueElementDialogDraggable.install = function(Vue, options) {

  Vue.directive('draggable', {

    // eslint-disable-next-line no-unused-vars
    bind : function(el, binding, vnode) {

      // get dialog or popover
      let dlg = el.getElementsByClassName("el-dialog")[0];
      if (!dlg) dlg = el.getElementsByClassName("el-popover")[0];
      // var dlg = el.querySelectorAll(".el-dialog, .el-popover")[0]

      // OLD
      // var title = el.getElementsByClassName("el-dialog__title")[0];
      // C.Glinsky: use custom title header
      // var title = el.getElementsByClassName("dialog-title-wrapper")[0]
      // title.style.userSelect="none";
      // title.style["-ms-user-select"] = "none";
      // title.style["-moz-user-select"] = "none";
      // // title.style.cursor="default";
      // // C.Glinsky: move icon
      // title.style.cursor="move";

      // initialize; arbitrary values
      dlg.offsetX = 0;
      dlg.offsetY = 0;

      let move = function(e){
        dlg.style.marginLeft = '0px';
        dlg.style.marginTop = '0px';  // required to avoid sudden jump on movement

        dlg.style.left = (e.pageX - dlg.offsetX) + 'px';
        dlg.style.top = (e.pageY - dlg.offsetY) + 'px';

        // DEBUG
        // console.log(window.getComputedStyle(el).paddingLeft); // 1340px
        // console.log(initPaddingLeft);
        // console.log(dlg.style.paddingLeft);  // object (no useful data)
        // console.log(el.style.paddingLeft);  // calc(-1em + 491px)
        // console.log([el.style.right, window.innerWidth]);  // ["1em", 766]
        // console.log(e.pageX);  // 515, 817
        // console.log(dlg.style.left);  // 475px, >1000px
        // console.log(dlg.offsetX);  // 177, 129
        // console.log([dlg.style.paddingLeft, dlg.style.marginLeft]);  // ["", "0px"], ["", "0px"]
      };

      let up = function () {
        removeEventListener('mousemove', move);
        removeEventListener('mouseup', up);
      };

      let down = function (e) {
        // allows use of dialogs or popovers not center aligned, e.g. <dh-dialog right='1em'>
        const initPaddingLeft = parseInt(window.getComputedStyle(el).paddingLeft.slice(0, -2));
        dlg.offsetX = (e.pageX - dlg.offsetLeft + initPaddingLeft);

        // dlg.offsetX = (e.pageX - dlg.offsetLeft);
        dlg.offsetY = (e.pageY - dlg.offsetTop);

        addEventListener('mousemove', move);
        addEventListener('mouseup', up);
      };

      // standard dialog header
      // var header = el.getElementsByClassName("el-dialog__header")[0];

      // custom dialog header
      let header = el.getElementsByClassName("dialog-title-wrapper")[0];
      header.addEventListener('mousedown', down);

      // style cursor
      header.style.cursor="move"
    },
  });
};

module.exports = vueElementDialogDraggable;
